/* Hibear: connected signups, responsive reviews, and media lifecycle. */
(function () {
  'use strict';
  function init() {
    if (document.getElementById('atc-sticky') || document.getElementById('md-sticky-atc')) {
      document.body.classList.add('hb-has-sticky-purchase');
    }

    // One real Judge.me widget, moved between the existing responsive sections.
    var reviews = document.getElementById('hb-real-reviews');
    var mobile = matchMedia('(max-width: 759px)');
    function placeReviews() {
      if (!reviews) return;
      var slot = document.querySelector('[data-hb-review-slot="' + (mobile.matches ? 'mobile' : 'desktop') + '"]');
      if (slot && reviews.parentNode !== slot) slot.appendChild(reviews);
      document.querySelectorAll('a[href="#reviews"],a[href="#reviews-mobile"]').forEach(function (link) {
        link.setAttribute('href', mobile.matches ? '#reviews-mobile' : '#reviews');
      });
    }
    placeReviews();
    mobile.addEventListener('change', placeReviews);

    document.querySelectorAll('form[data-hb-newsletter]').forEach(function (form, index) {
      var email = form.querySelector('input[type="email"]');
      var button = form.querySelector('button');
      if (!email || !button) return;
      email.name = 'email'; email.required = true; email.autocomplete = 'email'; email.maxLength = 254;
      email.setAttribute('aria-label', 'Email address');
      var note = document.createElement('p'); note.className = 'hb-signup-note'; note.id = 'hb-signup-note-' + index;
      note.innerHTML = 'By signing up, you agree to receive Hibear news and offers by email. Unsubscribe anytime. <a href="/pages/new-privacy-policy">Privacy policy</a>.';
      email.setAttribute('aria-describedby', note.id);
      form.appendChild(note);
      var status = document.createElement('p'); status.className = 'hb-signup-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
      var label = button.textContent;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        button.disabled = true; button.textContent = 'Signing up…'; status.textContent = '';
        var request = new XMLHttpRequest();
        request.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=YzR6Nq');
        request.timeout = 15000;
        request.setRequestHeader('Content-Type', 'application/vnd.api+json');
        request.setRequestHeader('revision', '2026-07-15');
        function retry() { button.disabled = false; button.textContent = label; status.textContent = 'We could not save your signup. Please try again.'; }
        request.onload = function () {
          if (request.status !== 202) { retry(); return; }
          email.hidden = true; button.hidden = true; note.hidden = true;
          status.textContent = 'Thanks for signing up. Check your inbox for a confirmation email if one is required.';
        };
        request.onerror = retry; request.ontimeout = retry;
        request.send(JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Hibear website newsletter',profile:{data:{type:'profile',attributes:{email:email.value.trim()}}}},relationships:{list:{data:{type:'list',id:'RXvQSp'}}}}}));
      });
    });

    var notify = document.getElementById('tumbler-notify-toggle');
    if (notify && location.hash === '#tumbler-notify') {
      notify.click();
      document.getElementById('tumbler-notify').scrollIntoView({block:'center'});
    }

    var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    function limitVideo() { return reduceMotion.matches || !!(navigator.connection && navigator.connection.saveData); }
    function hydrate(video) {
      var changed = false;
      if (!video.getAttribute('src') && video.dataset.hbSrc) { video.src = video.dataset.hbSrc; changed = true; }
      video.querySelectorAll('source[data-hb-src]').forEach(function (source) {
        if (!source.src) { source.src = source.dataset.hbSrc; changed = true; }
      });
      if (changed) video.load();
    }
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (!entry.isIntersecting || !video.getClientRects().length) { video.pause(); return; }
        if (limitVideo()) { video.controls = true; return; }
        if (video.id === 'trailer-video') return;
        hydrate(video); video.muted = true;
        var play = video.play(); if (play) play.catch(function () { video.controls = true; });
      });
    }, {threshold:0.1}) : null;
    function observeVideos(root) {
      var videos = root.matches && root.matches('video') ? [root] : root.querySelectorAll('video');
      videos.forEach(function (video) {
        if (video.dataset.hbObserved) return;
        video.dataset.hbObserved = '1';
        video.addEventListener('click', function () { if (!video.currentSrc) { hydrate(video); video.play().catch(function () {}); } });
        if (limitVideo()) { video.autoplay = false; video.pause(); video.controls = true; }
        if (observer) observer.observe(video); else { hydrate(video); video.controls = true; }
      });
    }
    observeVideos(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) { record.addedNodes.forEach(function (node) { if (node.nodeType === 1) observeVideos(node); }); });
    }).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) document.querySelectorAll('video').forEach(function (video) { video.pause(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
